import dayjs from 'dayjs';

dayjs.locale('ko');

export const campaginDateRange = {
  TODAY: dayjs().format('YYYY-MM-DD') as `${number}-${number}-${number}`,
  YESTERDAY: dayjs()
    .subtract(1, 'day')
    .format('YYYY-MM-DD') as `${number}-${number}-${number}`,
  TOMORROW: dayjs()
    .add(1, 'day')
    .format('YYYY-MM-DD') as `${number}-${number}-${number}`,
};

export const CAMPAIGN_DATE_TABS = [
  {
    id: campaginDateRange.YESTERDAY,
    content: '어제',
  },
  {
    id: campaginDateRange.TODAY,
    content: '오늘',
  },
  {
    id: campaginDateRange.TOMORROW,
    content: '내일',
  },
];
